import { PropType } from 'vue';
import mixins from 'vue-typed-mixins';

import KeystrokeInputableText from '@/components/keystrokeInputableText/KeystrokeInputableText.vue';
import PlbscfReadonlyValue from '@/components/plbscfReadonlyValue/PlbscfReadonlyValue.vue';
import PlbscfTableRow from '@/components/plbscfTableRow/PlbscfTableRow.vue';
import YearValueCell from '@/components/yearValueCell/YearValueCell.vue';
import C勘定科目ListEditItemButtons from '@/components/勘定科目/listEdit/button/item/勘定科目ListEditItemButtons.vue';

import { InputableTextMixin } from '@/components/inputableText/InputableText';

import { PlbscfInputableTextId } from '@/entries/user/mixins/PlbscfKeystrokeInputableTextMixin';
import 計画三表TableMixin from '@/entries/user/mixins/計画三表TableMixin';
import 計画書Mixin from '@/entries/user/mixins/計画書Mixin';

import AbstractPlbscfService, { PlbscfYearValue } from '@/classes/service/AbstractPlbscfService';
import Abstract計画PlbscfService, { Plbscf業績予測ListItem } from '@/classes/service/Abstract計画PlbscfService';
import 決算期Utility from '@/classes/common/決算期Utility';
import { E有無フラグ } from '@/openapi/enum';

export default mixins(InputableTextMixin, 計画書Mixin, 計画三表TableMixin).extend({
  name: 'C貸借損益TableRow',

  props: {
    listItem: {
      type: Object as PropType<Plbscf業績予測ListItem>,
      required: true,
    },
    isReadonlyTable: {
      type: Boolean,
      default: false,
    },
    listItemIndex: {
      type: Number,
      required: true,
    },
    map: {
      type: Array as PropType<PlbscfInputableTextId[][]>,
      required: true,
    },
    // monthlyValues の index が 0～readonlyMonthIndex であるものを入力不可とする
    // null ならば、全てのindexが入力可能
    readonlyMonthIndex: {
      type: Number,
      default: null,
    },
    isPls: {
      type: Boolean,
      default: false,
    },
  },

  components: {
    KeystrokeInputableText,
    C勘定科目ListEditItemButtons,
    YearValueCell,
    PlbscfReadonlyValue,
    PlbscfTableRow,
  },

  computed: {
    isReadonly(): boolean {
      return this.isReadonlyTable || this.listItem.業績予測 !== undefined;
    },
    業績予測Index(): number {
      return this.listItem.yearValues.length - 1;
    },
    業績予測Yv(): PlbscfYearValue {
      return this.listItem.yearValues[this.業績予測Index];
    },
    get計画0期Year(): number {
      const 計画0期Year = 決算期Utility.get計画0期の決算年();
      return this.計画書.c第1期月次作成フラグ === E有無フラグ.あり ? 計画0期Year + 1 : 計画0期Year;
    },
  },

  methods: {
    isNoValue(yearValue: PlbscfYearValue): boolean {
      return AbstractPlbscfService.isNoValue(this.listItem.config, yearValue);
    },
    isEditableMonth(yearValue: PlbscfYearValue, monthIndex: number): boolean {
      return (
        !this.isReadonlyTable &&
        AbstractPlbscfService.isEditable(this.listItem.config, yearValue) &&
        (this.readonlyMonthIndex === null || monthIndex > this.readonlyMonthIndex)
      );
    },
    getMonthlyValues(yv: PlbscfYearValue): number[] {
      return Abstract計画PlbscfService.getMonthlyValues(yv);
    },
  },
});
